<template>
  <section
    v-if="products"
    class="insu-prod-wrapper"
  >
    <div class="container">
      <p class="mb-m queryTips">
        您的期望保費
        <span>{{ tips.premiumLabel }}</span>
        ，找到
        <span>{{ prodsCount }}</span> 個方案，
        請選擇您想要投保的方案後，點擊下一步
      </p>
      <template v-if="prodsCount > 0">
      <!-- <CompulsoryNote v-if="selectedCom && selectedArb==null" v-bind="{ loading}" /> 
      <ArbitraryNote v-if="selectedArb && selectedCom==null" v-bind="{ loading}"/> -->

        <!-- <InsuProduct
          v-if="products.compulsory.length"
          v-model="selectedCom"
          v-bind="{isCollapse, triggerModal, loading}"
          reset
          collapse
          title="強制險方案"
          tips="是否需投保強制險"
          :prods="products.compulsory"
          :triggerScrollToProd="$attrs.triggerScrollToProd"
          @input="handleSelect"
        >
          <template slot="collapse">
            <div
              class="mt-xs switch-compulsory"
            >
              <i-switch 
                v-model="isCollapse" 
                @on-change="handleCollapse" 
              />
              <span
                class="fz-tiny"
              >
                我{{ isCollapse ? '需要': '不需要' }}投保強制險，{{ isCollapse ? '展開': '收合' }}強制險資訊
              </span>
            </div>
          </template>
        </InsuProduct>
        <InsuProduct
          v-if="products.arbitrary.length"
          v-bind="{triggerModal, loading}"
          v-model="selectedArb"
          title="任意險方案"
          tips="是否需加購任意險"
          :prods="products.arbitrary"
          @input="handleSelect"
        />
         -->
         <InsuProduct
          v-if="products.compulsory.length"
          v-model="selectedArb"
          v-bind="{triggerModal, loading}"   
          title="方案"         
          :prods="products.compulsory"
          :triggerScrollToProd="$attrs.triggerScrollToProd"
          @input="handleSelect"
        >        
        </InsuProduct>
        <InsuProduct
          v-if="products.arbitrary.length"
          v-bind="{triggerModal, loading}" 
          v-model="selectedArb"      
          :prods="products.arbitrary"
          :triggerScrollToProd="$attrs.triggerScrollToProd"
          @input="handleSelect"
        />
        <div class="text-right">
          <Button
            v-show="hasSelected"
            :loading="loading"
            :disabled="!hasSelected"
            class="btn-m btn-primary btn-shopping"
            @click="handlePagePurchase"
          >
            <span v-if="!loading">下一步</span>
            <span v-else>請稍候</span>
          </Button>
        </div>       
      </template>
      <template v-else>
        <ProdNotFound :triggerScrollToProd="$attrs.triggerScrollToProd" />
      </template>
    
    </div>
  </section>
</template>

<script>
  import { mapMutations } from 'vuex';
  // components  
  import { Button } from 'iview';
  import InsuProduct from '@/components/insurance/InsuProduct';
  import ProdNotFound from '@/components/insurance/ProdNotFound';
  // constants
  import { SELECT_INSU_MUTATION, RESET_SELECTED_MUTATION } from '@/store/modules/insurance/constants';
 // import CompulsoryNote from '@/components/modals/CompulsoryNote';
 // import ArbitraryNote from '@/components/modals/ArbitraryNote';

  export default {
    inheritAttrs: false,
    components: { Button, InsuProduct, ProdNotFound },
    //components: { Button, InsuProduct, ProdNotFound, ArbitraryNote, CompulsoryNote },
    props: {
     
      type: {
        type: String,
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      },
      hasSelected: {
        type: Boolean,
        default: null
      },
      products: {
        type: Object,
        default: null
      },
      tips: {
        type: Object,
        default: null
      },
      prodsCount: {
        type: Number,
        default: 0
      },
      triggerModal: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        isCollapse: false,
        selectedArb: null,
        //isCollapse: false,
        selectedCom: null        
      };
    },
    methods: {
      ...mapMutations([
        SELECT_INSU_MUTATION,
        RESET_SELECTED_MUTATION,
      ]),
      handleSelect(val) {
        // handleReset
        if (!val) return this.handleReset();
        // handleSelect
        const { selectedArb, selectedCom } = this;
        const payload = [selectedArb, selectedCom].filter(selected => selected !== null);
        this.SELECT_INSU_MUTATION(payload);
        //console.log("insuranceVehicle-payload:"+JSON.stringify(payload));
      },
      handleCollapse(val) {
        if (!val) return;
        this.selectedCom = null;
        const payload = this.selectedArb ? [this.selectedArb] : [];
        this.SELECT_INSU_MUTATION(payload);
      },
      handleReset() {
        this.selectedArb = null;
        this.selectedCom = null;
        this.RESET_SELECTED_MUTATION();
      },
      handlePagePurchase() {
        const { selectedArb, selectedCom, hasSelected } = this;
        if (!hasSelected) return;
        const payload = [selectedCom, selectedArb].reduce((acc, obj) => {
          if (obj === null) return [...acc];
          return [...acc, obj];
        }, []);
        this.triggerModal(payload);
      }
    }
  };
</script>